import {Component, OnInit} from '@angular/core';
import {AlertService} from "../services";
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import {MatDialog} from "@angular/material/dialog";
import {ComponentTitleService} from "../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";

import { locale as polish } from './i18n/pl';

import {CashReport} from "./model/cashReport";
import {Menu} from "../cms/menu/model/menu";
import {DeleteMenuDialogComponent} from "../cms/menu/dialog/deleteMenuDialog.component";
import {DeleteCashReportItemDialogComponent} from "./dialog/deleteCashReportItemDialog.component";
import {CashReportItemService} from "./service/cashReportItem.service";
import {CashReportItem} from "./model/cashReportItem";

@Component({
    templateUrl: './cashReportDetails.component.html',
    styleUrls: ['./cashReportDetails.component.scss']
})

export class CashReportDetailsComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    isAddMode: boolean;
    categories: any[];
    units: any[];
    createItemDialogRef: any;
    cashReport: CashReport;
    locale: string = 'pl';
    deleteDialogRef: any;

    constructor(
        public _matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private cashReportItemService: CashReportItemService,
    ) {
        this.translationLoader.loadTranslations(polish);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Cash report');
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.cashReport = this.route.snapshot.data.cashReport;


    }

    showConfirmCashReportItemDeleteDialog(event: CashReportItem) {
        this.deleteDialogRef = this._matDialog.open(DeleteCashReportItemDialogComponent, {
            panelClass: 'delete-cash-report-item-dialog',
            data      : {
                action : 'show',
                event: event,
            },
            width: '400px',
        });

        this.deleteDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.cashReportItemService.delete(event.id, response.value.reason).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.deleteDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }


}
